
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.934 16.894c0 4.45 3.631 7.595 8.75 7.595 5.809 0 9.801-3.76 9.801-9.94C19.485 4.905 11.041.511 4.882.511c-.973 0-1.454.482-1.454 1.041 0 .449.24.822.601 1.337.875 1.205 2.363 2.959 2.363 5.161 0 .187-.01.373-.033.57C5.747 7.47 4.664 6.66 3.351 6.66c-.372 0-.569.22-.569.537 0 .383.088.657.088 1.852 0 2.29-1.936 3.835-1.936 7.846zm8.97 4.515c-2.189 0-3.643-1.326-3.643-3.298 0-2.072 1.465-2.806 1.663-4.143.01-.11.087-.142.163-.066.547.472.887 1.063 1.149 1.743.055.12.142.131.197.033.601-1.052.71-2.62.569-4.592-.022-.11.054-.164.153-.12 2.593 1.183 3.916 3.759 3.916 6.07 0 2.324-1.367 4.373-4.168 4.373z","fill":"#F99128"}})])
          )
        }
      }
    